export default __webpack_public_path__ + "static/bottom_senior_students_outside_church-22a06842ece738a8692f10ce2ffd4204.jpg";